import { makeAutoObservable, runInAction } from 'mobx'
import { fetchStudentApplicationDocuments } from 'api/applicationDocuments'
import { mergeApplicationDocumentGroups } from '../utils/mergeApplicationDocumentGroups'
import { buildDocumentAssignLists } from '../utils/buildDocumentAssignItems'

class ApplicationDocumentsStore {
	studentId = ''
	groups = []
	isLoading = false
	loadError = ''

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	get flatItems() {
		return this.groups.flatMap(group => group.items || [])
	}

	get missingItemsForAssign() {
		return buildDocumentAssignLists(this.groups).missingItems
	}

	get uploadedItemsForAssign() {
		return buildDocumentAssignLists(this.groups).uploadedItems
	}

	setGroups(groups) {
		this.groups = groups || []
	}

	async load(studentId, { force = false } = {}) {
		const sid = String(studentId || '').trim()
		if (!sid) {
			this.studentId = ''
			this.groups = mergeApplicationDocumentGroups([], [])
			this.isLoading = false
			return
		}
		if (!force && this.studentId === sid && this.groups.length && !this.loadError) {
			return
		}

		this.studentId = sid
		this.isLoading = true
		this.loadError = ''
		try {
			const docsRes = await fetchStudentApplicationDocuments(sid)
			const merged = mergeApplicationDocumentGroups(
				docsRes?.groups,
				docsRes?.documents,
			)
			runInAction(() => {
				this.groups = merged
			})
		} catch {
			runInAction(() => {
				this.groups = mergeApplicationDocumentGroups([], [])
				this.loadError = 'load_failed'
			})
		} finally {
			runInAction(() => {
				this.isLoading = false
			})
		}
	}

	reload() {
		if (!this.studentId) return Promise.resolve()
		return this.load(this.studentId, { force: true })
	}
}

export const applicationDocumentsStore = new ApplicationDocumentsStore()
